const MODES =  {
    development : 'development',
    production : 'production',
    test : 'test',
};

export let clientId;
switch(process.env.NODE_ENV) {
    case MODES.test:
        clientId = "AXrq67myDfpbo56F-raMnbASrM03k_fNxDVLW2oe9zq4kWn-VjPHAXW9H_pHDHOUjR6OH5F7CXPecfkl";          // clientID Inovum - Merchant Sandbox
        break;
    case MODES.development:
        clientId = "AXrq67myDfpbo56F-raMnbASrM03k_fNxDVLW2oe9zq4kWn-VjPHAXW9H_pHDHOUjR6OH5F7CXPecfkl";          // clientID Inovum - Merchant Sandbox
        break;
    case MODES.production:
    default:
        // clientId = "AXrq67myDfpbo56F-raMnbASrM03k_fNxDVLW2oe9zq4kWn-VjPHAXW9H_pHDHOUjR6OH5F7CXPecfkl";          // clientID Inovum - Merchant Sandbox
        // clientId = "AcmI9GaDbQc_6lQfRkLYMGd-KFl5i10FU1YNAzDbQVY225VQl4kIZ6oyfeb7P1cTS9F3NjwldftVVklt";       // clientID EBS    - Merchant Sandbox (not working)
        clientId = "AV5kERIwGf6jIGOXKcv7f-SrR1a_Nk7ENk07Y78ZZpRKYUT3IHluczsaC0QGZ0pQv8tE4T1I330KTlXG";       // clientID EBS    - Merchant Live
        break;
}